import React from "react";

export enum FeedbackSeverity {
  SUCCESS = "success",
  INFO = "info",
  ERROR = "error",
  WARNING = "warning",
}

export interface FeedbackData {
  severity: FeedbackSeverity;
  message: string;
  position?: "bottom" | "top";
  action?: React.ReactNode;
}
